// components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { user, isLoading } = useAuth();

  console.log('ProtectedRoute: isLoading =', isLoading, 'user =', user);

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
      }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <span style={{ marginLeft: '10px' }}>Checking authentication...</span>
      </div>
    );
  }

  // If not authenticated, redirect to login
  if (!user) {
    console.log('ProtectedRoute: No user, redirecting to /login');
    return <Navigate to="/login" replace />;
  }

  // Check admin role if required
  if (requireAdmin && user.role !== "ADMIN" && user.role !== "EDITOR" && user.role !== "VIEWER") {
    console.log('ProtectedRoute: User is not admin, redirecting to /home');
    return <Navigate to="/home" replace />;
  }
  
  console.log('ProtectedRoute: User authenticated, rendering children');
  return children;
};

export default ProtectedRoute;



// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";

// const ProtectedRoute = ({ children, requireAdmin = false }) => {
//   const { user, isLoading } = useAuth();

//   if (isLoading) {
//     return <div>Loading...</div>; 
//   }

//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   if (requireAdmin && user.role !== "ADMIN") {
//     return <Navigate to="/" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute;